//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'BehcetDisease',
  data () {
    return {
      form: {
        oral: '0',
        genital: '0',
        ocular: '0',
        skin: '0',
        vascular: '0',
        nerve: '0',
        positive: '0',
      },
      hasScore: false,
      disabled: false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        let result = form.oral * 2 + form.genital * 2 + form.ocular * 2 + form.skin + form.vascular + form.nerve + form.positive
        self.hasScore = true
        return String(result)
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/RI/BehcetDisease.vue